// extracted by mini-css-extract-plugin
export default {"categoryBreadcrumbs":"DftGhhjY_VEmadxG56os-CategoryBreadcrumbs-categoryBreadcrumbs","categoryName":"q4Vke6UDw71VqM2KEDpm-CategoryBreadcrumbs-categoryName"};